class ButtonOverlayAction {
  constructor(params) {
    this.icon = params.icon;
    this.action = params.action;
    this.label = params.label;
  }
}

export { ButtonOverlayAction };
